import { Routes, Route } from 'react-router-dom';
import '../App.css';
import {
  Login,
  Main,
  Brand,
  Shop,
  ShopDetail,
  Notice,
  Cart,
  Order,
  SignUp,
  Mypage,
  Exchange,
} from './view';
import Payment from './view/Payment';
import PaymentSuccess from './view/PaymentSuccess';
import PaymentFail from './view/PaymentFail';
import { ToastProvider } from './context/ToastContext';
import { ModalProvider } from './context/ModalContext';
import GlobalToast from './components/ui/GlobalToast';
import GlobalModal from './components/ui/GlobalModal';
import OrderDetail from './view/OrderDetail';
import CreateReview from './view/CreateReview';
import FindId from './view/FindId';
import FindPassword from './view/FindPassword';
import PasswordResetComplete from './view/PasswordResetComplete';
import GloabalLayout from './components/ui/GloabalLayout';
import Header from './layout/header/Header.jsx';
import Footer from './layout/footer/Footer.jsx';
import { AuthProvider } from './context/AuthContext';
import NoticeDetail from './view/NoticeDetail';
import KakaoCallback from './view/auth/KaKaoCallback';
import NaverCallback from './view/auth/NaverCallback';
import './index.css';
import OnlyGuests from './routes/OnlyGuests';
import RequireAuth from './routes/RequireAuth';
import EssentialInfo from './view/EssentialInfo';
import QnA from './view/QnA';
import QnADetail from './view/QnADetail';
import CreateQnA from './view/CreateQnA';
import EditQnA from './view/EditQnA';
import OrderComplete from './view/OrderComplete';

export default function ShopApp() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ModalProvider>
          <Header />
          <GloabalLayout>
            <Routes>
              <Route path='/' element={<Main />} />
              {/* <Route path='/brand' element={<Brand />} /> */}
              <Route path='/shop' element={<Shop />} />
              <Route path='/shop-detail/:id' element={<ShopDetail />} />
              <Route path='/notice' element={<Notice />} />
              <Route path='/notice-detail/:id' element={<NoticeDetail />} />
              <Route path='/auth/kakao/callback' element={<KakaoCallback />} />
              <Route path='/auth/naver/callback' element={<NaverCallback />} />
              <Route
                path='/password-reset-complete'
                element={<PasswordResetComplete />}
              />

              <Route element={<OnlyGuests />}>
                <Route path='/login' element={<Login />} />
                <Route path='/signup' element={<SignUp />} />
                <Route path='/find-id' element={<FindId />} />
                <Route path='/find-password' element={<FindPassword />} />
                <Route path='/essential-info' element={<EssentialInfo />} />
              </Route>

              <Route element={<RequireAuth />}>
                <Route path='/cart' element={<Cart />} />
                <Route path='/order' element={<Order />} />
                <Route path='/mypage' element={<Mypage />} />
                <Route path='/order-detail/:id' element={<OrderDetail />} />
                <Route path='/exchange/:orderId' element={<Exchange />} />
                <Route path='/create-review/:id' element={<CreateReview />} />
                <Route path='/payment' element={<Payment />} />
                <Route path='/payment/success' element={<PaymentSuccess />} />
                <Route path='/payment/fail' element={<PaymentFail />} />
                <Route path='/qna' element={<QnA />} />
                <Route path='/qna/:id' element={<QnADetail />} />
                <Route path='/qna/create' element={<CreateQnA />} />
                <Route path='/qna/edit' element={<EditQnA />} />
                <Route path='/order/complete' element={<OrderComplete />} />
              </Route>
            </Routes>

            <GlobalToast />
            <GlobalModal />
          </GloabalLayout>
          <Footer />
        </ModalProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
